import { createContext, useContext } from "react";
import type { IFavouriteProviderContextValue } from "./FavouriteProvider.types";

export const FavouriteProviderContext = createContext<IFavouriteProviderContextValue>({} as IFavouriteProviderContextValue);

export function useFavouriteProviderContext() {
  return useContext(FavouriteProviderContext);
}
